import $ from 'jquery';

import { getServerUrl } from './utils';

// This is yucky and I hate this but I am worried that not having this
// will break things
let windowIsUnloading = false;
$(window).on('unload', () => {
  windowIsUnloading = true;
});

export function post_json(path, data, done, fail) {
  $.ajax({
    url: getServerUrl(path),
    type: 'POST',
    data: JSON.stringify(data) || '{}',
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
    contentType: 'application/json',
  })
    .done((r) => {
      done(r);
    })
    .fail((_, message, error) => {
      fail(error);
    });
}

export function jax(path, data, done, fail, verb) {
  $.ajax({
    url: getServerUrl(path),
    type: verb || 'POST',
    data: data || {},
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
  })
    .done((r) => {
      done(r);
    })
    .fail((_, message, error) => {
      if (windowIsUnloading) {
      // ignore if the page us unloading anyway, not a lot we can do about it.
        return;
      }

      fail(error);
    });
}

export function jaxPromise(route, data, verb) {
  return new Promise((res, rej) => {
    jax(
      route,
      data,
      res,
      rej,
      verb,
    );
  });
}
